import cx from 'classnames'
import { Text, TextFontSizes } from '@cinch-labs/design-system'
import { LOADING_TEXT } from '../../constants'

import skeletonStyles from '../../skeleton.module.css'
import styles from './subtitle.module.css'

interface SubtitleProps {
  isPending?: boolean
  className?: string
  fontSize?: keyof typeof TextFontSizes // TODO: Remove once Card Cards AB Test has concluded
  children?: React.ReactNode
}

const Subtitle = ({
  children,
  isPending = false,
  className = '',
  fontSize,
}: SubtitleProps) => {
  const isChildrenAString = typeof children === 'string'
  const content = isChildrenAString ? (
    <span dangerouslySetInnerHTML={{ __html: children }} />
  ) : (
    children
  )

  return (
    <Text
      fontSizeFixed={fontSize || 'xs'}
      className={cx(className, styles['subtitle'], {
        [skeletonStyles['base']]: isPending,
        [skeletonStyles['active']]: isPending,
      })}
    >
      {isPending ? LOADING_TEXT : content}
    </Text>
  )
}

export default Subtitle
